export const awsSnapshotPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/snapshots`,
  detail: (connectionId, region, snapshotId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/snapshots/${encodeURIComponent(region)}/${encodeURIComponent(snapshotId)}`,
  delete: (connectionId, region, snapshotId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/snapshots/${encodeURIComponent(region)}/${encodeURIComponent(snapshotId)}`,
};
